import { useQuery } from "@tanstack/react-query";
import { ActionsTable } from "Common/Components";
import { useEffect, useMemo, useState } from "react";
import { FetchUserByCompanySpecialPermission } from "services";
import { useAssigmentSpecialPermissionStore } from "../../store";
import { AssigmentSpecialPermission } from "interfaces";
import { useSessionStore } from "Common/Stores";

export const useAssignmentSpecialPermissionList = () => {
  const { session } = useSessionStore();
  const [company, setCompany] = useState<string>("");
  const { setIsOpenModal, setItem } = useAssigmentSpecialPermissionStore();

  useEffect(() => {
    if (session?.employe) {
      setCompany(session.employe.branch.company.id.toString());
    }
  }, [session?.employe]);

  const columns = useMemo(
    () => [
      {
        header: "ID",
        accessorKey: "index",
        cell: (cell: any) => cell.row.index + 1,
        enableColumnFilter: false,
      },
      {
        header: "Nombres",
        accessorKey: "names",
        enableColumnFilter: false,
      },
      {
        header: "Apellidos",
        accessorKey: "surnames",
        enableColumnFilter: false,
      },
      {
        header: "Email",
        accessorKey: "user.email",
        enableColumnFilter: false,
      },
      {
        header: "Teléfono",
        accessorKey: "phonenumber",
        enableColumnFilter: false,
      },
      {
        header: "Sucursal",
        accessorKey: "branch.description",
        enableColumnFilter: false,
      },
      {
        header: "Rol",
        accessorKey: "user.role.description",
        enableColumnFilter: false,
      },
      {
        header: "Acciones",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <ActionsTable
            isCustomEnabled
            onClickEdith={() => {
              handleSpecialPermission(cell.row.original);
            }}
            onClickDelete={() => {}}
          />
        ),
      },
    ],
    []
  );

  const handleSpecialPermission = (data: AssigmentSpecialPermission) => {
    setItem(data);
    setIsOpenModal(true);
  };

  const { data, refetch: refetchAssigmentSpecialPermission } = useQuery({
    queryKey: [
      "security-service-employees-employesByCompany-idCompany",
      company,
    ],
    queryFn: () => FetchUserByCompanySpecialPermission(Number(company)),
    enabled: Boolean(company),
  });

  return {
    columns,
    DataAssigment: data?.data.filter(
      (filter) => filter.user.role.permissions.length > 0
    ),
    refetchAssigmentSpecialPermission,
    session,
    company,
    setCompany,
  };
};
